module.exports = __webpack_public_path__ + "assets/img/jd.4ef5d12d.png";